import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import Navigation from '../../Commons/Navigation/Navigation'
import './GameBuilder.scss'
import Footer from '../../Commons/Footer/Footer'
import { useEffect, useRef, useState } from 'react'
import { gameFileInfoData, gameFileTest, layoutTypeInfoData } from './Commons'
import { v4 as uuidv4 } from 'uuid';
import DeckTopSection from '../../DeckBuilder/Decks/DeckTopSection'
import { useGameContext } from '../../Commons/GameContext'


// ADD STACK SECTION AUTO
export default function GameFileBuilder(props) {
    const gameFileInfo = { ...gameFileInfoData }
    const gameFileRef = useRef({ ...gameFileInfo.defaultValue })
    const [gameFile, setGameFile] = useState(gameFileRef.current)
    const [showImportModal, setShowImportModal] = useState(false)

    useEffect(() => {
        gameFileRef.current = gameFile
    }, [gameFile])

    function importCardData(data) {
        let JSONData = JSON.parse(JSON.stringify(data))
        setGameFile(JSONData)
    }

    return (
        <>
            <DeckTopSection>
                <div className='d-flex justify-content-between position-relative'>
                    <h1>Game file</h1>
                    <div className='d-flex'>
                        <Button variant="secondary" className='mx-1 my-auto' onClick={() => setShowImportModal(true)}>Import</Button>
                        <Button variant="secondary" className='mx-1 my-auto' onClick={() => {
                            const jsonStr = JSON.stringify(gameFileRef.current, null, 2); // Pretty-print with 2 spaces
                            const blob = new Blob([jsonStr], { type: "application/json" });
                            const url = URL.createObjectURL(blob);

                            const a = document.createElement("a");
                            a.href = url;
                            a.download = "Game_" + gameFileRef.current.name;
                            a.click();

                            URL.revokeObjectURL(url); // Clean up
                        }}>Download</Button>
                    </div>
                    {props.returnButton}
                </div>
            </DeckTopSection>
            <div className="below-navbar">
                <Container className="p-5 pt-0 position-relative" style={{ minHeight: "85vh" }}>
                    <div className='d-flex flex-column text-start mx-auto'>
                        <div className='box-container flex-column'>
                            <h5>Read before starting</h5>
                            <p>This part is long and not easy to understand at first. Make sure to read all the "?". Don't forget to download your file often so that in case of mistake or bug you can import a recent save. <b>You can import one of the game available in the app from the import button</b> if it can help you understand how everything works.</p>
                        </div>
                        <FormObject
                            section={gameFile}
                            parents=""
                            gameFileInfo={gameFileInfo}
                            gameFileRef={gameFileRef}
                            setGameFile={setGameFile}
                        />
                    </div>
                </Container>
            </div>
            <ImportModal
                show={showImportModal}
                handleClose={() => setShowImportModal(false)}
                loadData={(data) => importCardData(data)}
            />
        </>
    )
}

function ValueLabel({ gameFileInfo, keyName }) {
    if (gameFileInfo) {
        return (
            <div className='d-flex label-line align-items-center'>
                {gameFileInfo.labelName && (<Form.Label>{gameFileInfo.labelName}</Form.Label>)}
                {gameFileInfo.labelTitle && (<Form.Label className='title'>{gameFileInfo.labelTitle}</Form.Label>)}
                {gameFileInfo.labelSubtitle && (<Form.Label className='subtitle'>{gameFileInfo.labelSubtitle}</Form.Label>)}
                {gameFileInfo.help && (<div className='help'>
                    <p className='m-0 me-3 mark'>?</p>
                    <div className='content'>
                        <p className='m-0'>{gameFileInfo.help}</p>
                    </div>
                </div>)}
            </div>
        )
    }
    return (<Form.Label>{keyName}</Form.Label>)
}

function FormObject(props) {
    const [arrayId, setArrayIds] = useState(false)
    const [isInitialized, setIsInitialized] = useState(false)

    useEffect(() => {
        if (props.gameFileInfo.isDictionary) {
            let tmp = {}
            Object.keys(props.section).forEach((key, i) => {
                tmp[key] = { keyId: uuidv4(), order: i }
            })
            setArrayIds(tmp)


            // Check missing keys from dictionary
            if (props.gameFileInfo.defaultValue) {
                let keys = Object.keys(props.section)

                keys.forEach(key => {
                    let section = props.section[key]
                    Object.keys(props.gameFileInfo.defaultValue).forEach(k => {
                        if (section[k] === undefined) {
                            console.log("missing key " + k)
                            section[k] = props.gameFileInfo.defaultValue[k]
                        }
                    })
                })
            }
        }




        setIsInitialized(true)
    }, [])

    function addElement() {
        let newElement = JSON.parse(JSON.stringify(props.gameFileInfo.defaultValue))
        let tmp = { ...arrayId }
        let id = uuidv4()
        tmp[id] = { keyId: id, order: Object.keys(arrayId).length }
        setArrayIds(tmp)
        props.section[id] = newElement
        props.setGameFile({ ...props.gameFileRef.current })
    }

    function removeElement(key) {
        delete props.section[key]
        let tmp = { ...arrayId }
        delete tmp[key]
        setArrayIds(tmp)
        props.setGameFile({ ...props.gameFileRef.current })
    }

    function DeleteButton(keyValue) {
        return (<Button className="ms-auto text-nowrap" variant="secondary" onClick={() => { removeElement(keyValue.keyValue) }}>Delete</Button>)
    }

    if (!isInitialized) { return }
    if (arrayId && Object.entries(arrayId).length < Object.entries(props.section).length) { return }
    const isDictionary = arrayId !== false

    if (props.gameFileInfo.type == "Layout") {
        return (<SectionLayout_Wrapper
            section={props.section}
            sectionsDict={props.parentSection.sectionsDict}
        />)
    }

    return (
        <div className={'form-group' + (isDictionary ? ' d-flex flex-column' : '') + (props.gameFileInfo && props.gameFileInfo.className ? " " + props.gameFileInfo.className : "")}>
            <ValueLabel gameFileInfo={props.gameFileInfo} keyName={props.keyName} />
            {Object.entries(props.section).map(([key, value]) => {
                if (Array.isArray(value)) {
                    return (<div className='d-flex flex-column my-4' key={isDictionary ? arrayId[key].keyId : key}>
                        <FormArray
                            keyName={key}
                            array={value}
                            section={props.section[key]}
                            gameFileInfo={props.gameFileInfo ? props.gameFileInfo.dictionaryKey ? props.gameFileInfo.dictionaryKey : props.gameFileInfo[key] : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        {isDictionary && (<DeleteButton keyValue={key} />)}
                    </div>)
                } else if (value !== null && typeof value === "object") {
                    return (<div className='d-flex flex-column my-4' key={isDictionary ? arrayId[key].keyId : key}>
                        {isDictionary && (<Form.Control
                            type="text"
                            id="game-image"
                            placeholder={""}
                            defaultValue={key}
                            onChange={(e) => {
                                const newKey = e.currentTarget.value
                                let tmp = { ...arrayId }
                                tmp[newKey] = { ...tmp[key] }
                                delete tmp[key]
                                setArrayIds(tmp)

                                props.section[newKey] = { ...props.section[key] }
                                delete props.section[key]
                                props.setGameFile({ ...props.gameFileRef.current })
                            }}
                        />)}
                        <FormObject
                            keyName={key}
                            section={props.section[key]}
                            parentSection={props.section}
                            gameFileInfo={props.gameFileInfo ? props.gameFileInfo.dictionaryKey ? props.gameFileInfo.dictionaryKey : props.gameFileInfo[key] : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        {isDictionary && (<DeleteButton keyValue={key} />)}
                    </div>)
                } else {
                    return (<div className='d-flex my-0' style={isDictionary ? { order: arrayId[key].order } : {}} key={isDictionary ? arrayId[key].keyId : key}>
                        {isDictionary && (<div className='w-50 d-flex align-items-center'>
                            <Form.Control
                                type="text"
                                id="game-image"
                                placeholder={""}
                                defaultValue={key}
                                onChange={(e) => {
                                    const newKey = e.currentTarget.value
                                    let tmp = { ...arrayId }
                                    tmp[newKey] = tmp[key]
                                    delete tmp[key]
                                    setArrayIds(tmp)

                                    props.section[newKey] = props.section[key]
                                    delete props.section[key]
                                    props.setGameFile({ ...props.gameFileRef.current })
                                }}
                            />
                        </div>)}
                        <FormValue
                            keyName={key}
                            setProperty={(v) => {
                                props.section[key] = v
                                props.setGameFile({ ...props.gameFileRef.current })
                            }}
                            value={props.section[key]}
                            defaultValue={value}
                            gameFileInfo={props.gameFileInfo ? props.gameFileInfo.dictionaryKey ? props.gameFileInfo.dictionaryKey : props.gameFileInfo[key] : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        {isDictionary && (<div className='ms-4 d-flex align-items-center'><DeleteButton keyValue={key} /></div>)}
                    </div>)
                }
            })}
            {isDictionary && (<Button style={{ order: 9999 }} onClick={() => addElement()}>New entry</Button>)}
        </div>
    )
}

function FormArray(props) {
    const [arrayId, setArrayIds] = useState([])

    useEffect(() => {
        let tmp = []
        props.array.forEach(() => {
            tmp.push(uuidv4())
        })
        setArrayIds(tmp)
    }, [])

    function addElement() {
        let newElement = JSON.parse(JSON.stringify(props.gameFileInfo.defaultValue))
        let tmp = [...arrayId]
        tmp.push(uuidv4())
        setArrayIds(tmp)
        props.section.push(newElement)
        props.setGameFile({ ...props.gameFileRef.current })
    }

    function removeElement(index) {
        props.section.splice(index, 1)
        let tmp = [...arrayId]
        tmp.splice(index, 1)
        setArrayIds(tmp)
        props.setGameFile({ ...props.gameFileRef.current })
    }

    function DeleteButton(keyValue) {
        return (<Button className="ms-auto" variant="secondary" onClick={() => { removeElement(keyValue.keyValue) }}>-</Button>)
    }

    if (arrayId.length < props.array.length) { return }

    return (
        <div className={'form-group' + (props.gameFileInfo && props.gameFileInfo.className ? " " + props.gameFileInfo.className : "")}>
            <ValueLabel gameFileInfo={props.gameFileInfo ? props.gameFileInfo : false} keyName={props.keyName} />
            {Object.entries(props.section).map(([key, value]) => {
                if (Array.isArray(value)) {
                    return (<div className='d-flex flex-column my-4' id={arrayId[key]} key={arrayId[key]}>
                        <FormArray
                            keyName={key}
                            section={props.section[key]}
                            gameFileInfo={props.gameFileInfo ? props.gameFileInfo.arrayContent : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        <DeleteButton keyValue={key} />
                    </div>)
                } else if (value !== null && typeof value === "object") {
                    return (<div className='d-flex flex-column my-4' id={arrayId[key]} key={arrayId[key]}>
                        <FormObject
                            keyName={key}
                            section={props.section[key]}
                            gameFileInfo={props.gameFileInfo ? props.gameFileInfo.arrayContent : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        <DeleteButton keyValue={key} />
                    </div>)
                } else {
                    return (<div className='d-flex my-0' id={arrayId[key]} key={arrayId[key]}>
                        <FormValue
                            keyName={key}
                            setProperty={(v) => props.section[key] = v}
                            value={props.section[key]}
                            defaultValue={value}
                            gameFileInfo={props.gameFileInfo ? (props.gameFileInfo.arrayContent[key] ? props.gameFileInfo.arrayContent[key] : props.gameFileInfo.arrayContent["arrayKey"]) : false}
                            parents={props.parents + "." + key}
                            gameFileRef={props.gameFileRef}
                            setGameFile={props.setGameFile}
                        />
                        <div className='form-line w-auto ms-3'>
                            <DeleteButton keyValue={key} />
                        </div>
                    </div>)
                }
            })}
            <Button onClick={() => addElement()}>New</Button>
        </div>
    )
}

function FormValue(props) {
    const [isChecked, setIsChecked] = useState(props.defaultValue)
    if (!props.gameFileInfo) { return }

    if (props.gameFileInfo.type == "String") {
        return (<div className={'form-line' + (props.gameFileInfo.className ? " " + props.gameFileInfo.className : "")}>
            <ValueLabel gameFileInfo={props.gameFileInfo} keyName={props.keyName} />
            <Form.Control
                type="text"
                id="game-image"
                placeholder={""}
                defaultValue={props.defaultValue}
                onChange={(e) => {
                    props.setProperty(e.currentTarget.value)
                }}
            />
        </div>)
    } else if (props.gameFileInfo.type == "Number") {
        return (<div className='form-line'>
            <ValueLabel gameFileInfo={props.gameFileInfo} keyName={props.keyName} />
            <Form.Control
                type="number"
                id="game-image"
                placeholder={""}
                defaultValue={props.defaultValue}
                onChange={(e) => {
                    props.setProperty(e.currentTarget.value)
                }}
            />
        </div>)
    } else if (props.gameFileInfo.type == "Bool") {
        return (<div className='form-line'>
            <ValueLabel gameFileInfo={props.gameFileInfo} keyName={props.keyName} />
            <Form.Check
                type="switch"
                checked={isChecked}
                onChange={(e) => {
                    setIsChecked(!isChecked)
                    props.setProperty(!isChecked)
                }}
                className='ms-auto'
            />
        </div>)
    } else if (props.gameFileInfo.type == "Select") {
        return (<div className='form-line'>
            <ValueLabel gameFileInfo={props.gameFileInfo} keyName={props.keyName} />
            <Form.Select
                defaultValue={props.defaultValue}
                onChange={(e) => {
                    props.setProperty(e.currentTarget.value)
                }}
            >
                {props.gameFileInfo.choices.map((c, i) => {
                    return (<option key={c.value} value={c.value}>{c.title}</option>)
                })}
            </Form.Select>
        </div>)
    }
}











/*------------------------------ LAYOUT ------------------------------ */









function LayoutPreview(props) {
    return (
        <div className='d-flex flex-column my-4'>
            <p>This preview will helps you to visualize the layout defined here.</p>
            <div className='layout-preview position-relative'>
                <img className="w-100 h-100" src={require('../Assets/background.jpg')} />
                <div className='position-absolute w-100 h-100 start-0 top-0'>
                    <LayoutPreview_Section section={props.section} sectionsDict={props.sectionsDict} />
                </div>
            </div>
        </div>
    )

    function LayoutPreview_Section(props) {
        return (<div className={'w-100 h-100 d-flex flex-' + props.section.direction}>
            {props.section.content && props.section.content.map((c, i) => {
                if (c.section) {
                    const sectionDictVal = props.sectionsDict[c.section]
                    let height = "MEDIUM"
                    if (sectionDictVal) {
                        height = sectionDictVal.height
                    }
                    return (
                        <div className={'section-preview' + " height-" + height} key={i} style={c.style ? typeof c.style !== 'object' ? {} : c.style : {}}>
                            <h5 className='m-0'>{c.section}</h5>
                        </div>
                    )
                } else {
                    return (
                        <div className='group-preview h-100' key={i} style={c.style ? typeof c.style !== 'object' ? {} : c.style : {}}>
                            <LayoutPreview_Section section={c} sectionsDict={props.sectionsDict} />
                        </div>
                    )
                }
            })}
        </div>)
    }
}

function SectionLayout_Wrapper(props) {
    const [section, setSection] = useState(props.section)

    function updatePreview(sect) {
        if (sect === undefined) {
            setSection({ ...props.section })
        } else {
            setSection({ ...sect })
            props.section.isSymetricalForOpponents = sect.isSymetricalForOpponents
            props.section.direction = sect.direction
        }
    }

    useEffect(() => {
        updatePreview()
    }, [props.sectionsDict])

    return (<div className='d-flex flex-column'>
        <Form.Label className='subtitle'>Layout</Form.Label>
        <LayoutPreview
            section={section}
            sectionsDict={props.sectionsDict}
        />
        <LayoutSection
            section={section}
            updatePreview={updatePreview}
            isFirst={true}
        />
    </div>)
}

function LayoutSection(props) {
    const layoutData = { ...layoutTypeInfoData }
    const [direction, setDirection] = useState(props.section.direction)
    const [section, setSection] = useState(false)
    const [arrayId, setArrayIds] = useState([])

    useEffect(() => {
        if (props.section.content) {
            let tmp = []
            props.section.content.forEach(() => {
                tmp.push(uuidv4())
            })
            setArrayIds(tmp)
        }
        setSection(props.section)
        console.log(props.section, props.section.style)
    }, [])

    useEffect(() => {
        setSection(props.section)
    }, [props.section])

    function isStyleValid(style) {
        if (style === false) {
            return true
        }
        if (typeof style === 'object') {
            return true
        }
        return false
    }

    function addSectionGroup() {
        props.section.content.push({
            "direction": "column",
            "style": false,
            "content": [],
            "isSymetricalForOpponents": false
        })
        setSection({ ...props.section })

        let tmp = [...arrayId]
        tmp.push(uuidv4())
        setArrayIds(tmp)
        props.updatePreview()
    }

    function addPlayArea() {
        props.section.content.push({
            "section": "New_Section",
            "style": false
        })
        setSection({ ...props.section })

        let tmp = [...arrayId]
        tmp.push(uuidv4())
        setArrayIds(tmp)
        props.updatePreview()
    }

    function deleteContentElement(index) {
        props.section.content.splice(index, 1)
        setSection({ ...props.section })

        let tmp = [...arrayId]
        tmp.splice(index, 1)
        setArrayIds(tmp)
        props.updatePreview()
    }

    if (!section) { return }

    return (<div className='box-primary'>
        <div className='box-secondary d-flex flex-column m-0 w-100 align-items-start justify-content-center'>
            <Form.Select
                defaultValue={props.section.direction}
                onChange={(e) => {
                    props.section.direction = e.currentTarget.value
                    setSection({ ...props.section })
                    setDirection(e.currentTarget.value)
                    props.updatePreview(props.isFirst ? props.section : undefined)
                }}
            >
                {layoutData.direction.choices.map((c, i) => {
                    return (<option key={c.value} value={c.value}>{c.title}</option>)
                })}
            </Form.Select>
            <div className='d-flex w-100 my-1'>
                <ValueLabel gameFileInfo={{
                    labelName: "Is symetrical for opponents",
                    help: "Should the group be reversed for opponents to appear symmetrical to the the player board. Only reverse the direct children of the group, if the whole board should be symmetrical, set this to true to all groups."
                }} />
                <Form.Check
                    type="switch"
                    checked={section.isSymetricalForOpponents}
                    onClick={(e) => {
                        props.section.isSymetricalForOpponents = !section.isSymetricalForOpponents
                        setSection({ ...props.section })
                        props.updatePreview(props.isFirst ? props.section : undefined)
                    }}
                    className='ms-auto'
                />
            </div>
            <div className='d-flex w-100'>
                <ValueLabel gameFileInfo={{
                    labelName: "Style",
                    help: "CSS style object applied to the area (optional)"
                }} />
                <Form.Control
                    type="text"
                    placeholder={"example: { width: 12vh }"}
                    defaultValue={props.section.style ? JSON.stringify(props.section.style) : ""}
                    onChange={(e) => {
                        try {
                            let val = e.currentTarget.value
                            if (val == "") {
                                props.section.style = false
                            } else {
                                val = val.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
                                val = val.replace(/'/g, '"');
                                const style = JSON.parse(val)
                                props.section.style = style
                            }
                            props.updatePreview()
                        } catch (error) {
                            props.section.style = ""
                            props.updatePreview()
                            console.error("Error parsing JSON:", error.message);
                        }
                    }}
                />
                {!isStyleValid(props.section.style) && (<p className='text-nowrap'>Invalid style</p>)}
            </div>
        </div>
        <div className={"w-100 align-items-center d-flex flex-" + direction}>
            {props.section.content && props.section.content.map((c, i) => {
                if (c.section) {
                    return (
                        <div className='w-100 p-1 my-4' key={arrayId[i]}>
                            <div className='box-secondary d-flex flex-column m-0 w-100 align-items-start justify-content-center'>
                                <ValueLabel gameFileInfo={{
                                    labelSubtitle: "Section title",
                                    help: "Make sure the title here match the title used in 'Sections Data' below"
                                }} />
                                <Form.Control
                                    type="text"
                                    placeholder={""}
                                    defaultValue={c.section}
                                    onChange={(e) => {
                                        c.section = e.currentTarget.value
                                        props.updatePreview()
                                    }}
                                />
                                <div className='d-flex w-100'>
                                    <ValueLabel gameFileInfo={{
                                        labelName: "Style",
                                        help: "CSS style object applied to the area (optional)"
                                    }} />
                                    <Form.Control
                                        type="text"
                                        placeholder={"example: { height: 12vh }"}
                                        defaultValue={c.style ? JSON.stringify(c.style) : ""}
                                        onChange={(e) => {
                                            try {
                                                let val = e.currentTarget.value
                                                if (val == "") {
                                                    c.style = false
                                                } else {
                                                    val = val.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
                                                    val = val.replace(/'/g, '"');
                                                    const style = JSON.parse(val)
                                                    c.style = style
                                                }
                                                props.updatePreview()
                                            } catch (error) {
                                                c.style = ""
                                                props.updatePreview()
                                                console.error("Error parsing JSON:", error.message);
                                            }
                                        }}
                                    />
                                    {!isStyleValid(c.style) && (<p className='text-nowrap'>Invalid style</p>)}
                                </div>
                            </div>
                            <Button className='w-100' onClick={() => deleteContentElement(i)}>Delete {c.section}</Button>
                        </div>
                    )
                } else {
                    return (
                        <div className='w-100 p-1 my-4' key={arrayId[i]}>
                            <LayoutSection section={c} updatePreview={props.updatePreview} />
                            <Button className='w-100' onClick={() => deleteContentElement(i)}>Delete {direction}</Button>
                        </div>
                    )
                }
            })}
            {direction == "row" ? (
                <div className='d-flex flex-column'>
                    <Button className="m-1" onClick={() => addSectionGroup()}>Add group</Button>
                    <Button className="m-1" onClick={() => addPlayArea()}>Add area</Button>
                </div>
            ) : (
                <div className='d-flex flex-row'>
                    <Button className="m-1" onClick={() => addSectionGroup()}>Add group</Button>
                    <Button className="m-1" onClick={() => addPlayArea()}>Add area</Button>
                </div>
            )}
        </div>
    </div>)
}

function ImportModal(props) {
    const { gameData } = useGameContext()

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        // Check if a file is selected and is JSON
        if (file && file.type === "application/json") {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);
                    props.loadData({})
                    setTimeout(() => {
                        props.loadData(json)
                    }, 50)
                    props.handleClose()
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }
            };

            reader.readAsText(file);
        } else {
            alert("Please upload a valid .json file");
        }
    };

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Import existing game file</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {gameData && (<div className='box-container d-flex flex-column'>
                    <h5>Load current game</h5>
                    <p className='mb-3'>Replace the game file with the game file from the currently selected game.</p>
                    <Button onClick={() => {
                        props.loadData({})
                        setTimeout(() => {
                            props.loadData(gameData)
                        }, 50)
                        props.handleClose()
                    }}>Load game file</Button>
                </div>)}

                <div className='box-container d-flex flex-column'>
                    <h5>Import file</h5>
                    <p className='mb-3'>Replace the game file with the game file from a selected .JSON file.</p>
                    <div>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    props.handleClose()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}